module.exports = __webpack_public_path__ + "media/assets/images/book-f255f7570ac485637a956b7f6fcd360b.svg";